<h2 class="mb-6">Property access</h2>

<mat-radio-group class="grid gap-4" [ngModel]="createOperationCodes()">
  <div
    class="grid border rounded-lg"
    [class.cursor-pointer]="hasSmartlocks()"
    [class.cursor-not-allowed]="!hasSmartlocks()"
    (click)="hasSmartlocks() && updateTaskPropertyAccess(true)">
    <mat-radio-button class="!p-5" [value]="true" [disabled]="!hasSmartlocks()">
      <div class="flex flex-col gap-1 pl-2">
        <strong>Smart lock</strong>
        @if (hasSmartlocks()) {
          <span class="leading-relaxed text-text-tertiary">
            Automatically generate a smart lock code for the cleaner to access the property that can only be used when
            they arrive.
          </span>
        } @else {
          <span class="leading-relaxed text-[rgba(0,0,0,.38)]">
            Add a smart lock to this property to set this up.
          </span>
        }
      </div>
    </mat-radio-button>
  </div>

  <div class="grid border rounded-lg cursor-pointer" (click)="updateTaskPropertyAccess(false)">
    <mat-radio-button class="!p-5" [value]="false">
      <strong class="pl-2">Other access</strong>
    </mat-radio-button>
  </div>
</mat-radio-group>

<div class="mt-4 flex flex-col gap-3">
  <strong>Additional instructions</strong>
  <sbnb-textarea
    [ngModel]="note()"
    placeholder="Add entry instructions for your cleaner..."
    (ngModelChange)="updateTaskNote($event)" />
</div>
